
<template>
    <groups-page :is-staff="true" />
</template>

<script>
import GroupsPage from './groups-page.vue';
export default {
    components: {
        GroupsPage,
    },
};
</script>

<style>
</style>